import { A } from '@adornis/base/env-info.js';
import { translationsMatching } from '@adornis/bh-matching-translation/translations.js';
import { countryTranslations, languageTranslations } from '@adornis/bh-matching-user/entities/auto-matching-fields.js';
import { clientTranslator } from '@adornis/translation-core/client/clientTranslator.js';
import { Language } from '@adornis/translation-core/languages.js';
import { AccompanyingBuddyFfmUser, BuddyFfmUser } from './entities/buddy-ffm-users.js';

export const buddyFfmTranslations = {
  ...translationsMatching,
  user: {
    [BuddyFfmUser._class]: ['internationaler Buddy', 'international Buddy'],
    [AccompanyingBuddyFfmUser._class]: ['begleitender Buddy', 'support Buddy'],
    plural: {
      [BuddyFfmUser._class]: ['internationale Buddies', 'international Buddies'],
      [AccompanyingBuddyFfmUser._class]: ['begleitende Buddies', 'support Buddies'],
    },
  },
  enums: {
    ...translationsMatching.enums,
    MALE: ['Männlich', 'Male'],
    FEMALE: ['Weiblich', 'Female'],
    DIVERSE: ['Divers', 'Diverse'],
    NOT_SPECIFIED: ['Keine Angabe', 'Not specified'],
    SAME_SEX: ['Mentor/Buddy mit gleichem Geschlecht', 'Mentor/Buddy with same sex'],
    NO_PREFERENCE: ['Keine Präferenz', 'No preference'],
    JA: ['Ja', 'Yes'],
    NEIN: ['Nein', 'No'],
    KEIN: ['Kein Angabe', 'Nothing'],
    NEIN_MORE_THAN_2: [
      'Nein, ich habe schon zweimal oder öfter mitgemacht',
      'No, I have already participated twice or more',
    ],

    NO_DEPARTMENT_PREFERENCE: ['Keine Präferenz', 'No preference'],
    SAME_DEPARMENT_PREFERENCE: ['Buddy aus dem gleichen Studiengang', 'Buddy from the same department'],

    FIRST_BBUDDY_APPLICATION: ['Ja', 'Yes'],
    NOT_FIRST_BBUDDY_APPLICATION: ['Nein, ich war bereits Begleitbuddy', 'No, I have been a support buddy before'],
    NOT_FIRST_BBUDDY_APPLICATION_BUT_LAST_DID_NOT_WORK_OUT: [
      'Nein, aber ich wurde das letzte Mal nicht vermatcht',
      'No, but I was not matched last time',
    ],

    FIRST_IBUDDY_APPLICATION: ['Ja', 'Yes'],
    NOT_FIRST_IBUDDY_APPLICATION: [
      'Nein, ich war bereits internationaler Buddy',
      'No, I have been an international Buddy',
    ],
    NOT_FIRST_IBUDDY_APPLICATION_BUT_LAST_DID_NOT_WORK_OUT: [
      'Nein, aber ich wurde das letzte Mal nicht vermatcht',
      'No, but I was not matched last time',
    ],

    I_KNOW_THE_DATE: ['Ich weiß mein Ankunftsdatum (bitte angeben)', 'I know my arrival date (please specify)'],
    I_DONT_KNOW_YET: ['Ich weiß es noch nicht', "I don't know yet"],
    I_LIVE_IN_GERMANY: [
      'Ich lebe schon seit mehr als einem halben Jahr in Deutschland',
      'I live in Germany for more than half a year',
    ],
    I_STUDY_FROM_ABROAD: [
      'Ich studiere an der Goethe-Universität aus dem Ausland',
      'I study at Goethe University from abroad',
    ],

    ...languageTranslations,
    ...countryTranslations,

    GERMAN: ['Deutsch', 'German'],
    GERMAN_ENGLISH: ['Deutsch und Englisch', 'German and English'],
    ENGLISH: ['Englisch', 'English'],

    // support of mentor
    BEGLEITUNG_WAHRENDES_STUDIUMS: ['Begleitung während des Studiums', 'Support during your studies'],
    WEGE_IN_DIE_WISSENSCHAFT: ['Wege in die Wissenschaft', 'Ways into science'],
    ZUGANG_ZU_WIRTSCHAFTSUNTERNEHMEN: ['Zugang zu Wirtschaftsunternehmen', 'Access to business ventures'],
    WEGE_IN_DIE_SELBSTSTAEDIGKEIT: ['Wege in die Selbstständigkeit', 'Ways to independence'],
    BERATUNG_ZU_FUHRUNGSTHEMEN: ['Beratung zu Führungsthemen', 'Advice on leadership issues'],
    BERATUNG_ZU_KARRIERWEGEN: ['Beratung zu Karrierewegen', 'Advice on career paths'],
    BERATUNG_ZU_KARRIERSTRATEGIEN: ['Beratung zu Karrierestrategien', 'Advice on career strategies'],
    BERATUNG_ZU_VEREINBARKEIT_VOR_BERUF_UNTERNEHMEN: [
      'Beratung zu Vereinbarkeit von Beruf und Familie',
      'Advice on the compatibility of work and family',
    ],
    AUF_UND_AUSBAU_EINS_NETZWEITES: ['Auf- und Ausbau eines Netzwerkes', 'Establishment and expansion of a network'],
    ROLLE_AUF_DIE_FRAU_IN_MAENNERDOMINIERTEM_UMFELD_KLAEREN: [
      'Rolle als Frau in männerdominierten Umfeld klären',
      'Clariy the role of a woman in a male-dominated environment',
    ],
    PERSOENLICHKEITENKOMPETENZEN_ENTWICKELN: ['Persönlichkeitskompetenzen entwickeln', 'Develop personality skills'],
    SONSTIGES: ['Sonstiges und zwar:', 'Others:'],

    // Fachbereiche
    FB00: ['FB00 Lehramt', 'DEPT00 Teaching Degree'],
    FB01: ['FB01 Rechtswissenschaften', 'DEPT01 Law'],
    FB02: ['FB02 Wirtschaftswissenschaften', 'DEPT02 Economics'],
    FB03: ['FB03 Gesellschaftswissenschaften', 'DEPT03 Sociology'],
    FB04: ['FB04 Erziehungswissenschaften', 'DEPT04 Educational Sciences'],
    FB05: ['FB05 Psychologie und Sportwissenschaften', 'DEPT05 Psychology and Sports Sciences'],
    FB06: ['FB06 Evangelische Theologie', 'DEPT06 Protestant Theology'],
    FB07: ['FB07 Katholische Theologie', 'DEPT07 Catholic Theology'],
    FB08: ['FB08 Philosophie und Geschichtswissenschaften', 'DEPT08 Philosophy and Historical Sciences'],
    FB09: ['FB09 Sprach- und Kulturwissenschaften', 'DEPT09 Linguistic and Cultural Studies'],
    FB10: ['FB10 Neuere Philologien', 'DEPT10 Modern Philologies'],
    FB11: ['FB11 Geowissenschaften / Geographie', 'DEPT11 Geosciences / Geography'],
    FB12: ['FB12 Informatik und Mathematik', 'DEPT12 Computer Science and Mathematics'],
    FB13: ['FB13 Physik', 'DEPT13 Physics'],
    FB14: ['FB14 Biochemie, Chemie, Pharmazie', 'DEPT14 Biochemistry, Chemistry, Pharmacy'],
    FB15: ['FB15 Biowissenschaften', 'DEPT15 Life Sciences'],
    FB16: ['FB16 Medizin', 'DEPT16 Medicine'],

    // Fächer
    Afrikanistik: ['Afrikanistik', 'African Studies'],
    AllgundverglLiteraturwissenschaft: [
      'Allg. und vergl. Literaturwissenschaft',
      'General and Comparative Literature Studies',
    ],
    AmericanStudies: ['American Studies', 'American Studies'],
    AnglophoneLiteraturesCulturesandMedia: [
      'Anglophone Literatures, Cultures and Media',
      'Anglophone Literatures, Cultures and Media',
    ],
    Archaologie: ['Archäologie', 'Archaeology'],
    Archaometrie: ['Archäometrie', 'Archaeometry'],
    AudiovisualandCinemaStudies: ['Audiovisual and Cinema Studies', 'Audiovisual and Cinema Studies'],
    Betriebswirtschaftslehre: ['Betriebswirtschaftslehre', 'Business Administration'],
    Biochemie: ['Biochemie', 'Biochemistry'],
    Bioinformatik: ['Bioinformatik', 'Bioinformatics'],
    BiologieLehramt: ['Biologie (Lehramt)', 'Biology (Teaching Degree)'],
    Biophysik: ['Biophysik', 'Biophysics'],
    Biowissenschaften: ['Biowissenschaften', 'Biosciences'],
    Chemie: ['Chemie', 'Chemistry'],
    ChemieLehramt: ['Chemie (Lehramt)', 'Chemistry (Teaching Degree)'],
    ComparativeLiteratures: ['Comparative Literatures', 'Comparative Literatures'],
    CuratorialStudiesTheorieGeschichteKritik: [
      'Curatorial Studies - Theorie - Geschichte - Kritik',
      'Curatorial Studies - Theory - History - Criticism',
    ],
    DeutschLehramt: ['Deutsch (Lehramt)', 'German (Teaching Degree)'],
    DeutschPortugiesischeStudienEstudosLusoAlemaes: [
      'Deutsch-Portugiesische Studien / Estudos Luso-Alemães',
      'German-Portuguese Studies / Estudos Luso-Alemães',
    ],
    DeutscheLiteratur: ['Deutsche Literatur', 'German Literature'],
    Dramaturgie: ['Dramaturgie', 'Dramaturgy'],
    EmpirischeSprachwissenschaften: ['Empirische Sprachwissenschaften', 'Empirical Linguistics'],
    EnglischLehramt: ['Englisch (Lehramt)', 'English (Teaching Degree)'],
    EnglishStudies: ['English Studies', 'English Studies'],
    ErdkundeLehramt: ['Erdkunde (Lehramt)', 'Erdkunde (Teaching Degree)'],
    Erziehungswissenschaften: ['Erziehungswissenschaften', 'Educational Sciences'],
    Ethnologie: ['Ethnologie', 'Ethnology'],
    EvangelischeReligionLehramt: ['Evangelische Religion (Lehramt)', 'Protestant Religion (Teaching Degree)'],
    EvangelischeTheologie: ['Evangelische Theologie', 'Protestant Theology'],
    FilmkulturArchivierungProgrammierungPrasentation: [
      'Filmkultur: [Archivierung, Programmierung, Präsentation]',
      'Film Culture: [Archiving, Programming, Presentation]',
    ],
    FranzosischLehramt: ['Französisch (Lehramt)', 'French (Teaching Degree)'],
    GenderStudies: ['Gender Studies', 'Gender Studies'],
    Geographie: ['Geographie', 'Geography'],
    GeographienderGlobalisierungMarkteundMetropolen: [
      'Geographien der Globalisierung -Märkte und Metropolen',
      'Geographies of Globalization - Markets and Metropolises',
    ],
    Geowissenschaften: ['Geowissenschaften', 'Geosciences'],
    Germanistik: ['Germanistik', 'German Studies'],
    Geschichte: ['Geschichte', 'History'],
    GeschichteLehramt: ['Geschichte (Lehramt)', 'History (Teaching Degree)'],
    GeschichteundPhilosophiederWissenschaften: [
      'Geschichte und Philosophie der Wissenschaften',
      'History and Philosophy of Science',
    ],
    GriechischLehramt: ['Griechisch (Lehramt)', 'Greek (Teaching Degree)'],
    GriechischePhilologie: ['Griechische Philologie', 'Greek Philology'],
    Informatik: ['Informatik', 'Computer Science'],
    InformatikLehramt: ['Informatik (Lehramt)', 'Computer Science (Teaching Degree)'],
    InterdisciplinaryNeuroscience: ['Interdisciplinary Neuroscience', 'Interdisciplinary Neuroscience'],
    InternationalEconomicsandEconomicPolicy: [
      'International Economics and Economic Policy',
      'International Economics and Economic Policy',
    ],
    InternationalManagement: ['International Management', 'International Management'],
    InternationaleStudienFriedensundKonfliktforschung: [
      'Internationale Studien / Friedens- und Konfliktforschung',
      'International Studies / Peace and Conflict Research',
    ],
    IslamischeReligionLehramt: ['Islamische Religion (Lehramt)', 'Islamic Religion (Teaching Degree)'],
    IslamischeStudien: ['Islamische Studien', 'Islamic Studies'],
    ItalienischLehramt: ['Italienisch (Lehramt)', 'Italian (Teaching Degree)'],
    ItalienstudienStudiItaliani: ['Italienstudien / Studi Italiani', 'Italien Studies / Studi Italiani'],
    JapaninderWeltGlobaleHerausforderungenundkulturellePerspektiven: [
      'Japan in der Welt: [Globale Herausforderungen und kulturelle Perspektiven]',
      'Japan in the World: [Global Challenges and Cultural Perspectives]',
    ],
    Japanologie: ['Japanologie', 'Japanese Studies'],
    Judaistik: ['Judaistik', 'Jewish Studies'],
    KatholischeReligionLehramt: ['Katholische Religion (Lehramt)', 'Catholic Religion (Teaching Degree)'],
    KatholischeTheologie: ['Katholische Theologie', 'Catholic Theology'],
    Koreastudien: ['Koreastudien', 'Korean Studies'],
    KulturanthropologieundEuropaischeEthnologie: [
      'Kulturanthropologie und Europäische Ethnologie',
      'Cultural Anthropology and European Ethnology',
    ],
    KunstLehramt: ['Kunst (Lehramt)', 'Art (Teaching Degree)'],
    KunstMedienKulturelleBildung: ['Kunst-Medien-Kulturelle Bildung', 'Art-Media-Cultural Education'],
    Kunstgeschichte: ['Kunstgeschichte', 'Art History'],
    LateinLehramt: ['Latein (Lehramt)', 'Latin (Teaching Degree)'],
    LateinischePhilologie: ['Lateinische Philologie', 'Latin Philology'],
    Linguistics: ['Linguistics', 'Linguistics'],
    Linguistik: ['Linguistik', 'Linguistics'],
    Mathematik: ['Mathematik', 'Mathematics'],
    MathematikLehramt: ['Mathematik (Lehramt)', 'Mathematics (Teaching Degree)'],
    Medizin: ['Medizin', 'Medicine'],
    Medizintechnik: ['Medizintechnik', 'Medical Technology'],
    Meteorologie: ['Meteorologie', 'Meteorology'],
    ModernEastAsianStudies: ['Modern East Asian Studies', 'Modern East Asian Studies'],
    MolekulareBiotechnologie: ['Molekulare Biotechnologie', 'Molecular Biotechnology'],
    MolekulareBiowissenschaften: ['Molekulare Biowissenschaften', 'Molecular Biosciences'],
    MolekulareMedizin: ['Molekulare Medizin', 'Molecular Medicine'],
    MoneyandFinance: ['Money and Finance', 'Money and Finance'],
    MovingCulturesTransculturalEncounters: [
      'Moving Cultures - Transcultural Encounters',
      'Moving Cultures - Transcultural Encounters',
    ],
    MusikLehramt: ['Musik (Lehramt)', 'Music (Teaching Degree)'],
    Musikwissenschaft: ['Musikwissenschaft', 'Musicology'],
    Pharmazie: ['Pharmazie', 'Pharmacy'],
    Philosophie: ['Philosophie', 'Philosophy'],
    PhilosophieLehramt: ['Philosophie (Lehramt)', 'Philosophy (Teaching Degree)'],
    PhysicalBiologyofCellsandCellInteractions: [
      'Physical Biology of Cells and Cell Interactions',
      'Physical Biology of Cells and Cell Interactions',
    ],
    Physik: ['Physik', 'Physics'],
    PhysikLehramt: ['Physik (Lehramt)', 'Physics (Teaching Degree)'],
    PhysischeGeographie: ['Physische Geographie', 'Physical Geography'],
    PolitikundWirtschaftLehramt: ['Politik und Wirtschaft (Lehramt)', 'Politics and Economics (Teaching Degree)'],
    Politikwissenschaft: ['Politikwissenschaft', 'Political Science'],
    PolitischeTheorie: ['Politische Theorie', 'Political Theory'],
    Psychologie: ['Psychologie', 'Psychology'],
    Rechtswissenschaft: ['Rechtswissenschaft', 'Law'],
    Religionsphilosophie: ['Religionsphilosophie', 'Philosphy of Religion'],
    Religionswissenschaft: ['Religionswissenschaft', 'Religious Studies'],
    ReligionswissenschaftIslamischeReligion: [
      'Religionswissenschaft - Islamische Religion',
      'Religious Studies - Islamic Religion',
    ],
    ReligionswissenschaftVergleichendeReligionswissenschaft: [
      'Religionswissenschaft - Vergleichende Religionswissenschaft',
      'Religious Studies - Comparative Religion',
    ],
    Romanistik: ['Romanistik', 'Romance Studies'],
    RomanistischeLinguistik: ['Romanistische Linguistik', 'Romance Linguistics'],
    RomanistischeLiteraturundKulturwissenschaft: [
      'Romanistische Literatur und Kulturwissenschaft',
      'Romance Literature and Cultural Studies',
    ],
    SachunterrichtLehramt: ['Sachunterricht (Lehramt)', 'General Studies (Teaching Degree)'],
    Sinologie: ['Sinologie', 'Sinology'],
    Skandinavistik: ['Skandinavistik', 'Scandinavian Studies'],
    SoutheastAsianStudies: ['Southeast Asian Studies', 'Southeast Asian Studies'],
    SozialwissenschaftendesSports: ['Sozialwissenschaften des Sports', 'Social Sciences of Sport'],
    Soziologie: ['Soziologie', 'Sociology'],
    SpanischLehramt: ['Spanisch (Lehramt)', 'Spanish (Teaching Degree)'],
    SportLehramt: ['Sport (Lehramt)', 'Sport (Teaching Degree)'],
    SportmedizinischesTrainingLeistungsphysiologie: [
      'Sportmedizinisches Training/Leistungsphysiologie',
      'Sports Medical Training/Performance Physiology',
    ],
    Sportwissenschaft: ['Sportwissenschaft', 'Sports Science'],
    SprachenundKulturenSudostasiens: ['Sprachen und Kulturen Südostasiens', 'Languages and Cultures of Southeast Asia'],
    TheaterFilmuMedienwissenschaft: ['Theater-, Film- u. Medienwissenschaft', 'Theater, Film and Media Studies'],
    Umweltwissenschaften: ['Umweltwissenschaften', 'Environmental Sciences'],
    VoruFruhgeschichtlicheArchaologie: ['Vor- u. Frühgeschichtliche Archäologie', 'Pre- and Protohistoric Archaeology'],
    WirtschaftsundFinanzsoziologie: ['Wirtschafts- und Finanzsoziologie', 'Economics and Financial Sociology'],
    Wirtschaftsinformatik: ['Wirtschaftsinformatik', 'Business Informatics'],
    Wirtschaftspadagogik: ['Wirtschaftspädagogik', 'Business Education'],
    Wirtschaftssoziologie: ['Wirtschaftssoziologie', 'Economic Sociology'],
    Wirtschaftswissenschaften: ['Wirtschaftswissenschaften', 'Economics'],
    Zahnmedizin: ['Zahnmedizin', 'Dentistry'],
    otherMajor: ['Sonstiges', 'Others'],
    OkologieundEvolution: ['Ökologie und Evolution', 'Ecology and Evolution'],
    KEIN_NEBENFACH: ['Kein Nebenfach', 'No minor'],

    // Semester
    FIRST: ['1', '1'],
    SECOND: ['2', '2'],
    THIRD: ['3', '3'],
    FOURTH: ['4', '4'],
    FIFTH: ['5', '5'],
    SIXTH: ['6', '6'],
    SEVENTH: ['7', '7'],
    EIGHTH: ['8. Semester oder höher', '8th semester or higher'],

    // angestrebter abschluss
    BA: ['B.A. Bachelor of Arts', 'B.A. Bachelor of Arts'],
    BEd: ['B.Ed. Bachelor of Education', 'B.Ed. Bachelor of Education'],
    BEng: ['B.Eng. Bachelor of Engineering', 'B.Eng. Bachelor of Engineering'],
    BFA: ['B.F.A. Bachelor of Fine Arts', 'B.F.A. Bachelor of Fine Arts'],
    BSc: ['B.Sc. Bachelor of Science', 'B.Sc. Bachelor of Science'],
    LLB: ['LL.B. Bachelor of Laws', 'LL.B. Bachelor of Laws'],
    LLM: ['LL.M. Master of Laws', 'LL.M. Master of Laws'],
    Lehramt: ['Lehramt', 'Teaching Degree'],
    MA: ['M.A. Master of Arts', 'M.A. Master of Arts'],
    MEd: ['M.Ed. Master of Education', 'M.Ed. Master of Education'],
    MEng: ['M.Eng. Master of Engineering', 'M.Eng. Master of Engineering'],
    MFA: ['M.F.A. Master of Fine Arts', 'M.F.A. Master of Fine Arts'],
    MSc: ['M.Sc. Master of Science', 'M.Sc. Master of Science'],
    Staatsexamen: ['Staatsexamen', 'State Examination'],

    // Austauschtreffen mit Mentor
    PRESENCE: ['Präsenz (Raum Frankfurt)', 'Presence (Frankfurt)'],
    ONLINE: ['Nur Online', 'Only Online'],
    BOTH: ['Beides', 'Both'],

    // Bevorzug
    BEVORZUGT: ['Bevorzugt', 'Preferred'],
    OPTIONAL: ['Optional', 'Optional'],

    BERUFSEINSTIEG: ['Berufseinstieg', 'Career introduction'],
    PRAKTIKUM: ['Praktikum', 'Practice'],
    WERKSTUDENTENTAETIGKEIT: ['Werkstudententaetigkeit', 'Work student skills'],
    PROMOTION_PHD: ['Promotion PhD', 'Promotion PhD'],
    SELBSTSTAENDIGKEIT_FREIEBERUFLICH_TATIGKEIT: [
      'Selbstständigkeit, Freiberuflichkeit, Tatigkeit',
      'Independence, Freedom, Skills',
    ],
    AUSLANDERFAHRUNG: ['Auslanderfahrung', 'Foreign experience'],
  },
  buddy: {
    ...translationsMatching.buddy,
    mentorSignupTitle: ['Anmeldeformular für begleitende Buddys', 'Registration form for supporting buddies'],
    menteeSignupTitle: ['Anmeldeformular für internationale Buddys', 'Registration form for international Buddies'],
    allMentors: ['Alle Begleitende Buddies', 'All accompanying Buddies'],
    allMentees: ['Alle Buddys', 'All Buddys'],
    exportMenteeUser: ['Alle internationale Buddys exportieren', 'Export all international Buddys'],
    exportMentorUser: ['Alle begleitende Buddies exportieren', 'Export all accompanying Buddies'],
    sendCircularMail: {
      mentors: ['Rundmail an begleitende Buddies', 'Circular Mail to accompanying Buddies'],
      all: ['Rundmail an Alle', 'Circular Mail to Everyone'],
      mentees: ['Rundmail an internationale Buddys', 'Circular Mail to international Buddys'],
    },
  },
  route: {
    ...translationsMatching.route,
    'signup-mentor': ['Anmeldeformular für begleitende Buddys', 'Registration form for supporting buddies'],
    'signup-mentee': ['Anmeldeformular für internationale Buddys', 'Registration form for international buddies'],
    'fields-mentor': ['Felder für begleitende Buddies', 'Fields for accompanying Buddies'],
    'fields-mentee': ['Felder für internationale Buddies', 'Fields for international Buddies'],
  },
  field: {
    ...translationsMatching.field,
    departmentPreference: ['Studiengang Präferenz', 'Department Preference'],
    isFirstBBuddyApplication: [
      'Ist das deine erste Anmeldung als Begleitbuddy',
      'Is this your first application as an accompanying Buddy',
    ],
    isFirstIBuddyApplication: [
      'Ist das deine erste Anmeldung als internationaler Buddy',
      'Is this your first application as an international Buddy',
    ],
    hobbies: ['Hobbies und Interessen', 'Hobbies and Interests'],
    expectationsForBuddyMatching: [
      'Erwartungen an das Buddy-Programm (2-3 Sätze)',
      'Expectations for the Buddy-Program (2-3 sentences)',
    ],
    address: ['Adresse', 'Address'],
    'address.country': ['Land', 'Country'],
    'address.bundesland': ['Bundestland', 'State'],
    'address.additionalInfo': ['weitere Daten', 'additional info'],
    'address.streetAndHousenumber': ['Straße und Hausummer', 'street and housenumber'],
    'address.name': ['Adresse Person', 'Address Person'],
    'address.zipCity': ['PLZ/Stadt', 'Zip/City'],
    'address.zipCity.zip': ['PLZ', 'Zip'],
    'address.zipCity.city': ['Stadt', 'City'],
    'address.billingAddress': ['Rechnungsadresse', 'Billing Address'],

    country: ['Land', 'Country'],
    bundesland: ['Bundestland', 'State'],
    herkunftsland: ['Herkunftsland', 'Native Country'],
    additionalInfo: ['weitere Daten', 'additional info'],
    streetAndHousenumber: ['Straße und Hausummer', 'street and housenumber'],
    name: ['Adresse Person', 'Address Person'],
    zipCity: ['PLZ/Stadt', 'Zip/City'],
    zip: ['PLZ', 'Zip'],
    city: ['Stadt', 'City'],
    billingAddress: ['Rechnungsadresse', 'Billing Address'],

    emailRepeat: ['E-Mail bestätigen', 'Confirm E-Mail'],
    privacyPolicy: [
      `Ich habe die Datenschutzerklärung gelesen und stimme der Erhebung und Verarbeitung meiner Daten zu.`,
      `I have read the privacy agreement and consent to the collection and processing of my data.`,
    ],
    curriculumVitae: ['Lebenslauf', 'Curriculum Vitae'],
    preferredLanguage: ['Meine bevorzugte Sprache ist', 'My language preference is'],
    genderPreference: ['Präferenz (Geschlecht)', 'Preference (Gender)'],
    naechsteKarriereschritte: ['Nächste Karriereschritte', 'Next career steps'],
    naechsteKarriereschritteSonstiges: ['Sonstiges', 'Other'],
    whatIsNeededFromMentorSonstiges: ['Sonstiges', 'Other'],
    studiedAbroad: [
      'Ich habe meine Hochschulzugangsberechtigung im Ausland erworben:',
      'I have obtained my higher education permit in foreign countries:',
    ],
    erasmusStudent: ['Bist Du Erasmustudent', 'Are you an Erasmus student?'],
    searchingWork: [
      'Ist es Dein Ziel in Deutschland eine Arbeit zu finden?',
      'Is it your goal in Germany to find a job?',
    ],
    berufserfahrung: ['Berufserfahrung in Jahren', 'Professional experience in years'],
    sonstigesErfahrungen: [
      'Sonstiges (besondere Kenntnisse, Interessen, Mitgliedschaften, Ehrenamt o.ä.)',
      'Others (special skills, interests, memberships, honours etc.)',
    ],
    internationalMentees: ['Möchten Sie Internationals betreuen?', 'Do you want to support internationals?'],
    mentorSprache: ['Meine Mentoring-Sprache ist', 'My mentoring language is'],
    international: ['Kommen Sie ursprünglich aus dem Ausland?', 'Come from abroad?'],
    profilePicture: ['Profilbild', 'Profile Image'],
    extraSubjectSonstiges: ['Sonstiges Fachbereich', 'Other department'],
    preferedMentors: ['Bevorzugte begleitende Buddies', 'Preferred accompanying Buddies'],
    sorting: ['Sortierung festlegen', 'Set sorting'],
    sortingHide: ['Sortierung einklappen', 'Collapse sorting'],
    sortingChooseField: ['Feld auswählen', 'Select field'],
    sortingChooseDirection: ['Reihenfolge', 'Order'],
    sortingAsc: ['Aufsteigend', 'Ascending'],
    sortingDesc: ['Absteigend', 'Descending'],

    menteeSemester: ['Semester (Zum Start im SoSe 2025)', 'Semester (Start in SoSe 2025)'],
    productCopyID: ['Termin Kopie ID', 'Product Copy ID'],
    age: ['Alter', 'Age'],
    keyPath: ['ID', 'ID'],
    language: ['Sprache', 'Language'],
    translation: ['Übersetzung', 'Translation'],

    minSemesterPrerequisite: [
      'Voraussetzung zur Teilnahme am Buddy Matching: mindestens im 3. Bachelorsemester (Voraussetzung entfällt, sofern Du vorher bereits ein/e Studium/Ausbildung absolviert hast)',
      'Prerequisite to participate in the buddy matching: at least in 3rd year of bachelor studies (Prerequisite is not fulfilled if you have already completed a studies/training)',
    ],
    staatsangehoerigkeit: ['Staatsangehörigkeit', 'Nationality'],
    languageC1: ['Deutsch C1 vorhanden?', 'Do you have a German C1 certificate?'],
    whatIsNeededFromMentor: [
      'Welche Unterstützung wünschst Du Dir durch Deinen begleitenden Buddy?',
      'What support do you need from your accompanying buddy?',
    ],
    department: ['Fachbereich', 'Department'],
    mainSubject: ['Hauptfach', 'Main Subject'],
    extraSubject: ['Nebenfach', 'Extra Subject'],
    angestrebterAbschluss: ['Angestrebter Abschluss', 'Academic Degree'],
    angestrebterAbschlussSonstiges: ['Sonstige Angaben', 'Other information'],
    meetingType: ['Austauschtreffen mit begleitender Buddy/Buddy', 'Meeting with accompanying Buddy/Buddy'],
    sonstigesNotes: ['Sonstige Anmerkungen', 'Other notes'],
    motivationMentee: ['Motivation als Buddy (min. 200 Zeichen)', 'Motivation as Buddy (min. 200 characters)'],
    motivationMentor: [
      'Motivation als begleitender Buddy (min. 200 Zeichen)',
      'Motivation as accompanying Buddy (min. 200 characters)',
    ],
    firstTime: [
      'Ist dies Deine erste Bewerbung als Buddy bei GROW@Goethe?',
      'Is this your first application as a buddy at GROW@Goethe?',
    ],
    professionField: ['Welche Berufsfelder interessieren Dich?', 'What profession fields interest you?'],
    expectedGraduation: ['Voraussichtlicher Abschluss des Studiums', 'Expected graduation of the study'],
    expectedGraduationYear: ['Jahr', 'Year'],
    expectedGraduationMonth: ['Monat', 'Month'],
    firstGenerationStudent: ['Ich bin First Generation Student', 'I am a first generation student'],
    immigrantHistory: ['Ich habe eine Zuwanderungsgeschichte', 'I have a migration history'],
    businessProfile: ['Businessprofil (LinkedIn, etc.)?', 'Business profile (LinkedIn, etc.)?'],
    discoveredFrom: ['Ich habe vom Buddy-Programm erfahren durch:', 'I have learned from the buddy program:'],
    studium: ['Studium', 'Study'],
    abschluss: ['Abschluss', 'Graduation'],
    currentPosition: ['Aktuelle Position', 'Current Position'],
    currentOcupationFocus: ['Tätigkeitsschwerpunkt', 'Current skills'],
    berugserfahrung: ['Berufserfahrung in Jahren', 'Work experience in years'],
    menteeDepartments: [
      'In welchem Fachbereich sollen die Buddys studieren?',
      'In which department should the buddys study?',
    ],
    maxParallelMentees: [
      'Wie viele Studierende möchten Sie maximal parallel betreuen?',
      'How many students do you want to support in parallel?',
    ],
    goetheStudent: ['Sind Sie Alumni der Goethe Universität?', 'Are you an alumnus of Goethe University?'],
    abschlussarbeitBetreuen: [
      'Können Sie sich vorstellen, unabhängig vom Mentoring/vom Buddy, eine Abschlussarbeit zu betreuen?',
      'Can you present yourself independently of the mentoring/buddy, a graduation work?',
    ],
    workIntegratedLeaning: [
      'Können Sie sich vorstellen, Work-integrated learning in Ihrem Unternehmen anzubieten?',
      'Can you present yourself as a work-integrated learner in your company?',
    ],
    workIntegratedLeaningSonstiges: ['Sonstiges', 'additional information'],
    minSemesterPrerequisiteSonstiges: ['Sonstiges', 'Other'],
    fullName: ['Name', 'Name'],
    foreignLanguages: ['Fremdsprachen', 'Foreign languages'],
    germanLanguageLevel: ['deutsch Kentnisse', 'proficient in German'],
    arrivalType: ['Ankunft in Frankfurt', 'Arrival in Frankfurt'],
    arrivalDate: ['Ankunftsdatum', 'Arrival date'],
  },
};

export type TranslationDictionaryMentoring = typeof buddyFfmTranslations;
if (!A.isServer) {
  clientTranslator.updateDictionary(buddyFfmTranslations, [Language.GERMAN, Language.ENGLISH]);

  if (A.isDevelopment) globalThis.clientTranslator = clientTranslator;
}
